/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { GetRowIdParams, GridApi, GridOptions, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import {
  CurrentThemeService,
  DATA_GRID_FILTER_SERVICE,
  DATA_GRID_SERVICES,
  GridFilterService,
  GridService,
  TypesaurusCoreRef,
  TypesaurusCoreDocDef,
} from '..';

@Component({
  selector: 'nggc-base-ag-grid-tables',
  standalone: true,
  imports: [AgGridAngular, AgGridModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  template: ' <ag-grid-angular domLayout="autoHeight" class="ag-theme-material" [gridOptions]="gridOptions" /> ',
})
export class BaseAgGridTablesComponent<
  ModelDef extends TypesaurusCoreDocDef,
  StoreModel = ModelDef['Model'] & { ref: TypesaurusCoreRef<ModelDef> },
> implements OnInit {
  protected readonly gridService = inject<GridService<StoreModel>>(DATA_GRID_SERVICES);
  protected readonly filterService = inject<GridFilterService<StoreModel>>(DATA_GRID_FILTER_SERVICE);
  protected readonly onPaginationChangeSignal = signal<PaginationChangedEvent<StoreModel> | null>(null);
  protected columsToAutoSize: string[] = [];
  protected gridApi?: GridApi<StoreModel>;

  readonly themeService = inject(CurrentThemeService);
  readonly defaultValue$ = new BehaviorSubject<Record<string, StoreModel>>({});
  readonly dataLoading$ = new BehaviorSubject(true);
  readonly total$ = this.gridService.total$;

  readonly gridOptions = this.getGridOptions();

  ngOnInit(): void {
    computed(() => {
      this.onPaginationChangeSignal()?.api.autoSizeColumns(this.columsToAutoSize, false);
    });
  }

  refreshGrid() {
    this.gridApi?.refreshServerSide();
  }

  protected getGridOptions(): GridOptions<StoreModel> {
    console.error(new Error('Method not implemented yes, please implement your logic in the extended class'));
    return this.gridService.getOptions({
      onGridReady: (event: GridReadyEvent<StoreModel>) => {
        this.gridApi = event.api;
      },
      rowClassRules: {},

      getRowId: (params: GetRowIdParams) => String(params.data.ref.id),
      onPaginationChanged: (event: PaginationChangedEvent) => {
        this.onPaginationChangeSignal.set(event);
      },
      defaultColDef: {},
      columnDefs: [
        {
          headerName: 'ID',
          maxWidth: 150,
        },
        {
          colId: 'state',
          headerName: 'State',
          maxWidth: 100,
        },
        {
          colId: 'createdAt',
          headerName: 'Time',
          cellDataType: 'date',
          maxWidth: 250,
        },
      ],
    } as GridOptions<StoreModel>);
  }
}
